module.exports = "tr {\r\n\tcursor: pointer; \r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/budgets/budget-list/budget-list.component.css
// module id = ./src/app/budgets/budget-list/budget-list.component.css
// module chunks = main